const AlertIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
            width="16" height="14" fill="none"><path d="M7.064.5a1 1 0 0 1 1.732 0l6.928 12a1 1 0 0 1-.866 1.5H1.001a1 1 0 0 1-.866-1.5L7.064.5z" fill="#f19c1c" />
            <g fill="#222"><path fillRule="evenodd" d="M7.93 3.909a1 1 0 0 1 1 1v3.273a1 1 0 1 1-2 0V4.909a1 1 0 0 1 1-1z" />
                <path d="M8.93 11a1 1 0 1 1-2 0 1 1 0 1 1 2 0z" />
            </g>
        </svg>
    )
}

export default AlertIcon